import axios from "axios";
import jsonp from './jsonp';
import { getLoginUrl } from '../utils/utils';
import UxMessage from '@cloud-sn/uxcool/es/message';

// const CancelToken = axios.CancelToken;
// const source = CancelToken.source();

class Requset {
  getInstance() {
    return this.axiosInstance
  }
  constructor() {
    this.config = {
      timeout: 5000,
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        // 'Content-Type': 'application/x-www-form-urlencoded'
        // 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
      },
      // cancelToken: source.token
    }
    this.axiosInstance = axios.create(this.config);
    this.axiosInstance.interceptors.request.use((config) => {
      //  return jsonp("/fuwu/authStatus").then((res) => {
      //       if(res.hasLogin) {
      //         return config
      //       } else {
      //         window.location.href = getLoginUrl();
      //       }
      //   }, () => {
      //     UxMessage.error('网络异常')
      //   })
        return config
    });
    this.axiosInstance.interceptors.response.use((res) => {
      console.log(res)
      if(res.data.idsIntercepted) {
        jsonp("/fuwu/authStatus").then((res) => {
          if(!res.hasLogin) {
            window.location.href = getLoginUrl();
          }
        }, () => {
          UxMessage.error('网络异常')
        })
      } else {
        if(res.data.errCode === '0000' ) {
          const data =  res.data.data || res.data;
          return Promise.resolve(data);
        } else {
          res.data.data = {
            datas: []
          }
          return Promise.reject(res.data.errMsg);
        }
      }
    },
    (error) => {
      return Promise.reject(error)
    });
  }
}

const request = new Requset();
const axiosInstance = request.getInstance();
export default axiosInstance;